import { ref } from '@vue/composition-api'
import store from '@/store'
import { FETCH_PROFILE } from '@/store/modules/auth.module'
import { GET_COUNTRIES, GET_COMMON_AUTH } from '@/store/modules/common.module'
import { useSegmentation } from './useSegmentation'
import { useAddresses } from './useAddresses'

export function useOperations() {
  const isLoaded = ref(false)
  const countries = ref([])
  const kingpinPresenceCountries = ref([])
  const originalSegmentationData = ref(null)

  const segmentation = useSegmentation()
  const addresses = useAddresses()

  function fetchAllResources() {
    return Promise.all([
      store.dispatch(FETCH_PROFILE, true),
      store.dispatch(GET_COUNTRIES),
      store.dispatch(GET_COMMON_AUTH),
    ])
  }

  function extractResponseData(res, key) {
    return res?.data?.data?.[key] || []
  }

  function applyCountries(countriesRes, commonAuthRes) {
    countries.value = extractResponseData(countriesRes, 'COUNTRIES')
    kingpinPresenceCountries.value = extractResponseData(commonAuthRes, 'KINGPIN_PRESENCE_COUNTRIES')
  }

  function buildSegmentationData(profile) {
    return {
      departments: profile.departments,
      restrictedCountries: profile.restrictedCountries,
      avgRetailPrice: profile.avgRetailPrice,
      avgWholesalePrice: profile.avgWholesalePrice,
      minimumOrderValue: profile.minimumOrderValue,
    }
  }

  function initializeSegmentation(profile) {
    const segData = buildSegmentationData(profile)
    originalSegmentationData.value = JSON.parse(JSON.stringify(segData))
    segmentation.initSegmentation(segData, countries.value, kingpinPresenceCountries.value)
  }

  function initializeAddresses(profile) {
    const profileAddresses = profile?.addresses || []
    addresses.initAddresses(profileAddresses, false)
  }

  async function fetchOperationsData() {
    try {
      const [profile, countriesRes, commonAuthRes] = await fetchAllResources()
      applyCountries(countriesRes, commonAuthRes)
      initializeSegmentation(profile)
      initializeAddresses(profile)
      isLoaded.value = true
    } catch {
      // error toast handled by axios interceptor
    }
  }

  return {
    isLoaded,
    countries,
    kingpinPresenceCountries,
    originalSegmentationData,
    segmentation,
    addresses,
    fetchOperationsData,
  }
}
